import React, { forwardRef } from 'react';

import FormGroup, { FormGroupProps } from '@mui/material/FormGroup';

import FormControl from '../FormControl/FormControl.jsx';
import FormLabel from '../FormLabel/FormLabel.jsx';
import { SwitchProps } from '../Switch/Switch.jsx';

export interface SwitchGroupProps extends FormGroupProps {
  /**
   * Display text over the radio group.
   */
  groupLabel?: string;
  /**
   * The position of the label.
   */
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  /**
   * The value of the initially selected radio button.
   */
  value?: string;
  /**
   * The content of the component.

   */
  children?: React.ReactNode;
  /**
   * The size of the component. small is equivalent to the dense checkbox styling.
   */
  size?: SwitchProps['size'];
  color?: SwitchProps['color'];
  /**
   * The name used to reference the value of the control.

   */
  name?: string;
  /**

   */
  onKeyDown?: FormGroupProps['onKeyDown'];
  /**
   * display selection controls in a single row.
   */
  row?: boolean;
  /**
   * Change event
   */
  onChange?: FormGroupProps['onChange'];
  checked?: boolean;
}

const emptyFunction = () => undefined;

const SwitchGroup = forwardRef((props: SwitchGroupProps, ref) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{props.groupLabel}</FormLabel>
      <FormGroup onChange={emptyFunction} {...props} ref={ref}>
        {props.children}
      </FormGroup>
    </FormControl>
  );
});

export default SwitchGroup;
